import { Injectable, TemplateRef, signal } from '@angular/core';

/**
 * QuickViewService — singleton para el popover de quick view de grillas.
 *
 * Un solo popover global existe en el DOM (renderizado por QuickViewPopoverComponent
 * en app.component). El caller llama `open(tpl, x, y)` para mostrar el template
 * en la posicion dada, y `close()` para cerrarlo.
 *
 * Patrón: hover en una card/row >500ms → service.open(...). Mouse leave o
 * scroll → service.close(). Long-press en mobile → idem.
 */

export interface QuickViewState {
  template: TemplateRef<unknown>;
  x: number;
  y: number;
  /** Datos opcionales pasados al template context (`let-data`). */
  data?: unknown;
}

@Injectable({ providedIn: 'root' })
export class QuickViewService {
  readonly state = signal<QuickViewState | null>(null);

  open(template: TemplateRef<unknown>, x: number, y: number, data?: unknown): void {
    this.state.set({ template, x, y, data });
  }

  close(): void {
    this.state.set(null);
  }
}
